import React, { useState } from "react";
import { Table } from "react-bootstrap";
import TableRow from "../../components/TableRow";
import { calcularVariacao, formatarDecimal, formatarPorcentagem } from "../../core/utils/funcoes";
import Skeleton from "react-loading-skeleton";
import { ModeloCentroDistribuicaoFatorDefinicao } from "../../core/models/centroDistribuicao";
import { useTranslation } from "react-i18next";


interface Props {
  carregar: boolean;
  listaDefinicaoMkt: ModeloCentroDistribuicaoFatorDefinicao[];
}

export default function CentroDistribuicaoPainelDefinicao(props: Props) {

  const { t } = useTranslation();
  const [tamanho,setTamanho] = useState(2);

  React.useEffect(() => {
    setTamanho(props.listaDefinicaoMkt.length)
  },[props.listaDefinicaoMkt])

  return (
    <div>
      <div className="d-flex align-items-center justify-content-between mb-1">
        <h5 className="mb-0">{t("pages.Definição Mkt")}</h5>
      </div>

      <Table className="rounded mb-0" hover bordered striped responsive style={{ overflow: 'hidden' }}>
        <thead>
          <tr>
            {/* <TableRow>Empresa</TableRow> */}
            <TableRow>{t("pages.Toneladas")}</TableRow>
            <TableRow>{t("pages.Variação")}</TableRow>
            <TableRow>{t("pages.Faturamento")}</TableRow>
            <TableRow>{t("pages.Variação")}</TableRow>
          </tr>
        </thead>

        <tbody>

          {props.carregar ?
            Array.from({ length: tamanho }).map(
              (_, index) => (
                <tr className="height-26" key={"skeleton-tr" + index}>
                  {Array.from({ length: 4 }).map((_, index) => (
                    <td key={"skeleton-td" + index}>
                      <Skeleton />
                    </td>
                  ))}
                </tr>
              ))
            :
            props.listaDefinicaoMkt.map((_, index) => (
              <tr key={"painelDefinicao" + index}>
                {/* <td>{_.des_empresa}</td> */}
                <td >{formatarDecimal(_.num_mkt_tonelada/1000)}</td>
                <td>{formatarPorcentagem(calcularVariacao(_.num_mkt_tonelada, _.num_ia_tonelada))}</td>
                <td>{formatarDecimal(_.num_mkt_faturamento, true)}</td>
                <td>{formatarPorcentagem(calcularVariacao(_.num_mkt_faturamento, _.num_ia_faturamento))}</td>
              </tr>
            ))
          }

        </tbody>

        <tfoot className="fw-bold">
          {props.carregar ?
            <tr className="height-26">
              <td> <Skeleton baseColor="white" /></td>
              <td> <Skeleton baseColor="white" /></td>
              <td> <Skeleton baseColor="white" /></td>
              <td> <Skeleton baseColor="white" /></td>
            </tr>
            :
            <tr >
              {/* <td>Total</td> */}
              <td>{formatarDecimal(props.listaDefinicaoMkt.reduce((acumulador, objeto) => acumulador + objeto.num_mkt_tonelada, 0)/1000, false)}</td>
              <td> &nbsp;</td>
              <td>{formatarDecimal(props.listaDefinicaoMkt.reduce((acumulador, objeto) => acumulador + objeto.num_mkt_faturamento, 0), true)}</td>
              <td> &nbsp;</td>
            </tr>
          }
        </tfoot>
      </Table>
    </div>
  );
}
